module.exports = __webpack_public_path__ + "static/scale-model-of-rachel-the-piggy-bank-in-seattle-washington-27ecbcbdf97d8b50cb33b6c9f11d9422.png";